import { CreateDiscountCodeForAdminState } from './createDiscountCodeForAdmin.types'

const initialState: CreateDiscountCodeForAdminState = {
  loading: false,
  error: null,
  success: null
}

export default initialState
